<template>
    <div class="container is-max-desktop">
        <div
            class="header is-flex is-flex-direction-row p-5 px-6"
            style="justify-content: center; min-height: 100px"
        >
            <div
                class="title is-4 is-inline-block mt-5"
                style="align-self: center; white-space: nowrap"
            >
                {{ $t('GET_DISCOUNT') }}
            </div>
            <img
                class="ml-4"
                style="width: 130px"
                :src="$env.getAppLogo().logo"
            />
        </div>
        <div class="question p-5">
            <div class="pl-5 is-flex is-flex-wrap-wrap">
                <img
                    class="mr-3"
                    style="width: 30px"
                    :src="getDollarBanknoteAssetUrl()"
                />

                <div class="title is-5 is-inline-block">
                    {{ $t('INSURANCE_TITLE') }}
                </div>
                <div class="content">
                    <p>
                        {{ $t('INSURANCE_CONTENT_1_1') }}
                        <span class="has-text-weight-bold">{{
                            $t('INSURANCE_CONTENT_1_2')
                        }}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="instruction p-5">
            <div class="title is-5 pl-5">
                {{ $t('INSURANCE_TITLE_2') }}
            </div>
            <div class="pl-5">
                <ol>
                    <li class="content">{{ $t('INSURANCE_CONTENT_2_1') }}</li>
                    <li class="content">{{ $t('INSURANCE_CONTENT_2_2') }}</li>
                    <li class="content">{{ $t('INSURANCE_CONTENT_2_3') }}</li>
                </ol>
            </div>
        </div>
        <div
            class="p-5 is-flex is-justify-content-center is-align-content-center footer-part"
        >
            <div class="title is-5 mr-5" style="max-width: 50%">
                {{ $t('INSURANCE_TITLE_3') }}
            </div>
            <div class="counter">{{ insurance_count }}</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            insurance_count: 0
        }
    },
    computed: {
        JWT() {
            return this.$route.query.jwt
        }
    },
    methods: {
        getDollarBanknoteAssetUrl() {
            const banknoteEmoji = 'emojis/128/objects/dollar-banknote.png'
            const assetsUrl = process.env.VUE_APP_ASSETS_URL
            return new URL(`/static/${banknoteEmoji}`, assetsUrl).toString()
        },
        async getUserFromJWT(jwt) {
            const { sid } = JSON.parse(atob(jwt.split('.')[1]))
            return sid
        },
        async getInsuranceCount() {
            try {
                const sid = await this.getUserFromJWT(this.JWT)
                const { data } = await this.$api.get(`v1/polonica/stats/${sid}`)
                this.insurance_count = data.kids
            } catch (error) {
                this.$Network.handleError(error)
            }
            return
        }
    },
    mounted() {
        this.getInsuranceCount()
    }
}
</script>
<style lang="scss" scoped>
* {
    font-family: 'Regular';
    color: black;
}
.container {
    margin-top: 5%;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    max-width: 430px;
    @media (max-width: 700px) {
        margin-top: 0;
        overflow-y: scroll;
    }
}
.title {
    font-family: 'SemiBold';
    color: black;
    font-weight: 400;
    font-size: 18px !important;
}
.header {
    background-color: rgba(73, 155, 248, 0.2);

    img {
        position: relative;
        top: -0.1rem;
    }
    .title {
        font-size: 24px !important;
    }
}
.question {
    min-height: 150px;
    .content {
        margin-top: -0.2rem;
        max-width: 90%;
        font-size: 14px;
    }
    img {
        position: relative;
        top: -0.85rem;
        margin-right: 0.5rem;
        @media (max-width: 700px) {
            margin-right: 0.05rem;
        }
    }
}
.instruction {
    background-color: rgba(73, 155, 248, 0.2);
    .content {
        max-width: 95%;
        font-size: 14px;
    }
}
ol {
    list-style: none;
    counter-reset: item;
}
li {
    padding-left: 2.4rem;
    counter-increment: item;
    margin-bottom: 5px;
}
li:before {
    content: counter(item) '.';
    font-family: 'SemiBold';
    font-size: 30px;
    position: absolute;
    left: 3rem;
    display: inline-block;
    transform: translateY(-12%);
}

.counter {
    background-color: rgb(73, 155, 248);
    width: 160px;
    height: 70px;
    border-radius: 14px;
    text-align: center;
    font-weight: bold;
    color: #fff;
    font-size: 56px;
    line-height: 140%;
}
.footer-part .title {
    margin-top: 1.1rem;
}
</style>
